export { deepMergeSimple } from '../utilities/deepMergeSimple.js'
